import React from 'react'
import PropTypes from 'prop-types'

import useStyles from './modal.style'

import Button from '@components/button/button.component'

const Modal = (props) => {
  const { children, isVisible, onClose } = props

  const classes = useStyles(props)

  return (
    <div className={`modal${isVisible ? ' is-active is-clipped' : ''}`}>
      <div className='modal-background' />
      <div className={`modal-content ${classes.content}`}>
        {children}
        <Button
          aria-label='close'
          className='button is-primary is-fullwidth'
          onClick={onClose}
          type='button'
        >
          Close
        </Button>
      </div>
    </div>
  )
}

Modal.defaultProps = {
  children: null,
  isVisible: false,
  onClose: () => { }
}

Modal.propTypes = {
  children: PropTypes.node,
  isVisible: PropTypes.bool,
  onClose: PropTypes.func
}

export default Modal
